// Public landing-page URL for a namespaced company id, or null for an id
// with no page. SPA mirror of the worker's ``companyPageUrl``
// (portal/worker/src/watch/email_render.ts) — kept intentionally
// duplicated (both are ~4 lines) rather than sharing a module across the
// worker/app boundary; a renamed id shape breaks both call sites'
// typecheck-free string matching the same way, so drift risk is low.
export function companyUrl(companyId: string): string | null {
  const m = companyId.match(/^([a-z]{2})-([a-z0-9]+)-([A-Za-z0-9]+)$/);
  if (!m) return null;
  return `https://plaingraph.com/company/${m[1]}/${m[2]}/${m[3]}`;
}

// The INTERNAL portal detail route for a company id, or null when the id
// isn't a namespaced company the detail view can resolve. Deliberately
// broader than companyUrl above: the portal detail page also serves
// supranational `lei-*` issuers that have NO public landing page, so gating
// an internal link on companyUrl (a public-page predicate) wrongly drops
// them. Any namespaced id (`cc-reg-local` or `lei-LEI`) is routable — the
// detail route 404s cleanly for anything genuinely unknown, so this only
// filters non-namespaced junk (bare numbers, empty strings) that would
// otherwise link to a guaranteed dead end. Mirrors the direct-id affordance
// regex on the Companies search page.
export function companyDetailPath(companyId: string): string | null {
  const ok =
    /^[a-z]{2}-[a-z0-9]+-[A-Za-z0-9]+$/i.test(companyId) ||
    /^lei-[A-Za-z0-9]+$/i.test(companyId);
  return ok ? `/companies/${encodeURIComponent(companyId)}` : null;
}
